module.exports = __webpack_public_path__ + "fa2cb2b962b426d66dc25f54aca5b6af.svg";